"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/01/31
 */
Object.defineProperty(exports, "__esModule", { value: true });
const port_1 = require("../port");
const version_json_1 = require("../version.json");
const system = {
    initialise: ({ appName, appVersion, vendor, onMessage }) => {
        if (typeof onMessage !== "function") {
            throw new Error("[partner-comm] onMessage should be a function");
        }
        (0, port_1.setPortListener)(onMessage);
        (0, port_1.sendMessage)({
            type: "initialise",
            message: { appName, appVersion, vendor, partnerSdkVersion: version_json_1.version },
        });
    },
    sendMessage: (message) => {
        (0, port_1.sendMessage)(message);
    },
    getContext: () => {
        (0, port_1.sendMessage)({
            type: "request",
            message: {
                action: "getContext",
                interface: "system",
            },
        });
    },
    getLocale: () => {
        (0, port_1.sendMessage)({
            type: "request",
            message: {
                action: "getLocale",
                interface: "system",
            },
        });
    },
    getTheme: () => {
        (0, port_1.sendMessage)({
            type: "request",
            message: {
                action: "getTheme",
                interface: "system",
            },
        });
    },
};
exports.default = system;
//# sourceMappingURL=system.js.map